import { getProjectId, post_data } from "../helpers/functions";
import Modal from "./modal";

export default class Uploader extends Modal {
  constructor() {
    super();
    this.elementToDeleteId;
    this.location = location.href.split("projects")[0];
  }
  updateUplaodedFiles = () => {
    const input = document.querySelector("#fileInputForm");
    document
      .querySelectorAll(".editor-form__documents > li")
      [this.elementToDeleteId].remove();

    if (input.files.length === 0) return;
    const filesArray = Array.from(input.files);
    // Remove the first file
    filesArray.splice(this.elementToDeleteId, 1);

    // Create a new FileList object
    const newFileList = new DataTransfer();

    filesArray.forEach((file) => {
      newFileList.items.add(file);
    });
    // Set the new FileList
    input.files = newFileList.files;
  };

  deleteFileButton = async (e) => {
    e.preventDefault();
    const element = document.querySelectorAll(
      ".editor-form__documents > li > span"
    )[this.elementToDeleteId];
    const projectId = await getProjectId();
    const form = new FormData();
    form.append(
      "data",
      JSON.stringify({
        function: "delete_file",
        id: projectId,
        name: element.textContent,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    return response;
  };

  toggleFileDeleteModal = (e) => {
    const div = document.createElement("div");
    this.elementToDeleteId = e.target.getAttribute("data-id");
    div.innerHTML = this.delete_modal("file", "File", this.elementToDeleteId);
    document.body.append(div);
  };
}
